import {
  ADD_USER,
  GET_USER,
  GET_USERS,
  DELETE_USER,
  UPDATE_USER,
  REQUEST_ADD_USER,
  REQUEST_UPDATE_USER
} from '../mutation-types'

const state = {
  all: [],
  user: {},
  userCreated: false,
  userUpdated: false
}

const mutations = {
  // User find
  [GET_USERS] (state, users) {
    state.all = users
    state.userAdded = false
  },
  [GET_USER] (state, user) {
    state.user = user
  },
  // User creation
  [REQUEST_ADD_USER] (state) {
    state.userCreated = false
  },
  [ADD_USER] (state, user) {
    state.all.push(user)
  },
  // User update
  [REQUEST_UPDATE_USER] (state) {
    state.userUpdated = false
  },
  [UPDATE_USER] (state, oldUser, updatedUser) {
    state.all.$remove(oldUser)
    state.all.push(updatedUser)
    state.userUpdated = true
  },
  // User delete
  [DELETE_USER] (state, user) {
    state.all.$remove(user)
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/users.js